(function(scope){
  const deliveryKey='Plazo de entrega', both=['1-2 Días Hábiles','2-3 Semanas'];
  const valuesOf=v=>Array.isArray(v)?[...new Set(v)]:(v?[String(v)]:[]);
  function evaluate(records,selected,candidate=()=>true){
    const chosen=selected[deliveryKey]||[];
    const active=Object.entries(selected).filter(([key,values])=>key===deliveryKey?!(both.every(v=>chosen.includes(v))):values.length);
    const matches=[],counts=new Map();
    for(const record of records){
      if(!candidate(record))continue;
      let failed=null,failures=0;
      for(const [key,values] of active){if(!values.some(value=>valuesOf(record.fields[key]).includes(value))){failed=key;if(++failures>1)break;}}
      if(!failures)matches.push(record);
      if(failures>1)continue;
      const fields=failures?[[failed,record.fields[failed]]]:Object.entries(record.fields);
      for(const [key,raw] of fields){let group=counts.get(key);if(!group){group=new Map();counts.set(key,group);}for(const value of valuesOf(raw))group.set(value,(group.get(value)||0)+1);}
    }
    const rank=r=>r.fields[deliveryKey]===both[0]?0:r.fields[deliveryKey]===both[1]?1:2;
    matches.sort((a,b)=>rank(a)-rank(b));
    return {matches,count:(key,value)=>counts.get(key)?.get(value)||0};
  }
  const api={evaluate};if(typeof module!=='undefined'&&module.exports)module.exports=api;else scope.KleverFacetEvaluation=api;
})(typeof window==='undefined'?globalThis:window);
(async () => {
  if(typeof document==='undefined')return;
  const root = document.querySelector('[data-collection-title]');
  const sort = document.querySelector('#KleverSearchSort');
  sort?.addEventListener('change', () => { const url=new URL(location.href);url.searchParams.set('sort_by',sort.value);url.searchParams.delete('page');location.assign(url.href); });
  let list = document.querySelector('#KleverProductList');
  const data = window.KleverTechnicalData;
  const quick = document.querySelector('[data-quick-filters]');
  const quickKeys = root?.classList.contains('kif-unified-catalog') ? ['Plazo de entrega'] : ['Plazo de entrega','Marca'];
  if (!root || !data) return;
  if(!list && root.querySelector('.kb-empty')) {
    root.classList.add('kif-empty-category');
    root.querySelector('.kb-empty h2').textContent='Esta subcategoría aún no tiene productos publicados';
    root.querySelector('.kb-empty p').textContent='Explora las categorías del menú o utiliza el buscador general para encontrar una alternativa.';
    return;
  }
  if(!list)return;
  const presentation = root.dataset.filterLayout === 'category' ? window.KleverCategoryFilters : null;
  let topUI = null;
  const loading=root.querySelector('[data-category-loading]');
  const status=loading.querySelector('span');
  const overview=root.querySelector('[data-category-overview]');
  let records = [], definitions = [], selected = {}, term = '', limit = 25;
  const originalURL = new URL(location.href);
  try {
    const saved = JSON.parse(originalURL.searchParams.get('spec') || '{}');
    if (saved && typeof saved === 'object' && !Array.isArray(saved)) selected = Object.fromEntries(Object.entries(saved).filter(([k,v])=>k.length<100&&Array.isArray(v)&&v.every(s=>typeof s==='string'&&s.length<150)));
  } catch (_) { /* Ignore malformed saved filters. */ }
  if (!Object.prototype.hasOwnProperty.call(selected,'Plazo de entrega')) selected['Plazo de entrega']=['1-2 Días Hábiles','2-3 Semanas'];
  if (presentation) {
    selected = presentation.normalizeSelection(selected);
    // Product search belongs exclusively to the global header.
    originalURL.searchParams.delete('within');
    history.replaceState(null, '', originalURL);
  }
  const more = document.createElement('button');
  more.type = 'button'; more.className = 'kt-more'; more.textContent = 'Mostrar más productos';
  const empty = document.createElement('p'); empty.className='kt-empty'; empty.hidden=true;
  empty.textContent='No hay productos que combinen estos criterios. Quita un filtro o pulsa Restablecer.';
  if (presentation) empty.textContent='No hay productos que combinen estos criterios. Quita una selección o pulsa Limpiar filtros.';
  list.after(empty,more); more.hidden=true;
  const deliveryKey='Plazo de entrega';
  const deliveryValues=['1-2 Días Hábiles','2-3 Semanas'];
  const candidates = record => (!term || record.search.includes(data.normalize(term)));
  function apply(save = true) {
    const applyStarted=performance.now();
    const evaluated=window.KleverFacetEvaluation.evaluate(records,selected,candidates);
    const matches=evaluated.matches;
    // Keep unchanged cards attached when counts or another facet change.
    const shown=matches.slice(0,limit).map(record=>record.node);
    const retained=new Set(shown);
    for(const node of [...list.children])if(!retained.has(node))node.remove();
    shown.forEach((node,index)=>{
      if(list.children[index]!==node)list.insertBefore(node,list.children[index]||null);
      node.hidden=false;
    });
    more.hidden=matches.length<=limit; empty.hidden=matches.length>0;
    status.textContent=`${matches.length.toLocaleString('es-CL')} de ${records.length.toLocaleString('es-CL')} productos`;
    const visible = document.querySelector('#KleverVisibleProducts');
    if (visible) visible.textContent=`${matches.length.toLocaleString('es-CL')} de ${records.length.toLocaleString('es-CL')}`;
    const note = document.querySelector('#KleverResultsNote');
    const pending=matches.filter(record=>!record.fields[deliveryKey]).length;
    if (note) note.textContent=`${Math.min(limit,matches.length)} mostrados · Filtros aplicados a toda la categoría${pending?` · ${pending} con plazo por confirmar`:""}`;
    for (const input of filterInputs()) {
      const count=evaluated.count(input.dataset.key,input.value);
      input.checked=(selected[input.dataset.key]||[]).includes(input.value);
      input.disabled=!count&&!input.checked;
      input.closest('label').querySelector('small').textContent=count;
    }
    if (quick) {
      quick.querySelectorAll('[data-quick-key]').forEach(filter=>{
        const count=(selected[filter.dataset.quickKey]||[]).length;
        const badge=filter.querySelector('[data-selection-count]');
        badge.textContent=count;badge.hidden=!count;
        filter.classList.toggle('has-selection',Boolean(count));
      });
      
    }
    topUI?.update({selected,term,total:records.length,count:matches.length});

    if (save) {
      const url=new URL(location.href);
      const active=Object.fromEntries(Object.entries(selected).filter(([key,v])=>key===deliveryKey||v.length));
      if(Object.keys(active).length)url.searchParams.set('spec',JSON.stringify(active)); else url.searchParams.delete('spec');
      if (presentation) {
        if (term) url.searchParams.set('within', term); else url.searchParams.delete('within');
      }
      url.searchParams.delete('page');
      history.replaceState(null,'',url);
    }
    document.dispatchEvent(new CustomEvent('klever:products-added'));
    root.dataset.filterApplyMs=(performance.now()-applyStarted).toFixed(1);
    performance.measure('klever:filter-apply',{start:applyStarted,end:performance.now()});
  }
  function filterInputs() {
    if (topUI) return [...topUI.inputs(),...(quick?.querySelectorAll('input[type="checkbox"]')||[])];
    return [...(quick?.querySelectorAll('input[type="checkbox"]')||[])];
  }
  function setQuickOpen(filter,open) {
    filter.querySelector('[data-quick-toggle]').setAttribute('aria-expanded',String(open));
    filter.querySelector('.kb-quick-filter__menu').hidden=!open;
    filter.classList.toggle('is-open',open);
  }
  function closeQuick(except) {
    quick?.querySelectorAll('.kb-quick-filter.is-open').forEach(filter=>{
      if(filter!==except)setQuickOpen(filter,false);
    });
  }
  function renderQuick() {
    if (!quick) return;
    quick.replaceChildren();
    for (const key of quickKeys) {
      const definition=definitions.find(item=>item.key===key);
      const filter=document.createElement('div');filter.className='kb-quick-filter';filter.dataset.quickKey=key;
      const toggle=document.createElement('button');toggle.type='button';toggle.className='kb-quick-filter__toggle';toggle.dataset.quickToggle='';toggle.setAttribute('aria-expanded','false');
      const title=document.createElement('span');title.textContent=key;
      const badge=document.createElement('span');badge.className='kb-quick-filter__badge';badge.dataset.selectionCount='';badge.hidden=true;
      const chevron=document.createElement('span');chevron.className='kb-quick-filter__chevron';chevron.setAttribute('aria-hidden','true');
      toggle.append(title,badge,chevron);filter.append(toggle);
      const menu=document.createElement('div');menu.className='kb-quick-filter__menu';menu.id='KleverQuickFilter-'+quickKeys.indexOf(key);menu.hidden=true;toggle.setAttribute('aria-controls',menu.id);
      const options=document.createElement('div');options.className='kb-quick-filter__options';

      for (const value of definition.values) {
        const label=document.createElement('label');label.dataset.value=value;
        const input=document.createElement('input');input.type='checkbox';input.value=value;input.dataset.key=key;input.setAttribute('aria-label',value);
        const thumbnail=document.createElement('span');thumbnail.className='kb-quick-filter__thumbnail';thumbnail.setAttribute('aria-hidden','true');
        if(key==='Marca'){
          thumbnail.dataset.cardBrand=value;thumbnail.textContent=value.split(/\s+/).map(word=>word[0]).slice(0,2).join('');
        }else{
          const icon=document.createElement('img');icon.src=value==='2-3 Semanas'?quick.dataset.importIcon:quick.dataset.localIcon;icon.alt='';icon.width=36;icon.height=30;thumbnail.append(icon);
        }
        const name=document.createElement('span');name.className='kb-quick-filter__name';
        const deliveryPilot=root.classList.contains('kif-unified-catalog') && key==='Plazo de entrega';
        name.textContent=deliveryPilot ? (value==='2-3 Semanas' ? '2–3 Semanas' : 'Inmediata') : value;
        if(deliveryPilot)input.setAttribute('aria-label',name.textContent);
        const count=document.createElement('small');count.setAttribute('aria-hidden','true');
        label.append(input,thumbnail,name,count);options.append(label);
      }
      menu.append(options);filter.append(menu);quick.append(filter);
      if(root.classList.contains('kif-unified-catalog') && key==='Plazo de entrega') {
        filter.classList.add('kb-quick-filter--inline');
        const heading=document.createElement('span');heading.className='kif-delivery-label';heading.textContent='Entrega';
        toggle.hidden=true;filter.prepend(heading);menu.hidden=false;
      }
      toggle.addEventListener('click',()=>{
        const open=toggle.getAttribute('aria-expanded')!=='true';
        closeQuick(filter);setQuickOpen(filter,open);
      });
    }
    const clear=document.createElement('button');clear.type='button';clear.className='kb-quick-filter__clear';clear.dataset.clearQuick='';clear.textContent='Limpiar filtros';clear.setAttribute('aria-label','Limpiar plazo de entrega y marca');
    clear.addEventListener('click',()=>{quickKeys.forEach(key=>selected[key]=[]);limit=25;apply();});
    quick.hidden=false;
  }
  if(quick){
    document.addEventListener('click',event=>{if(!quick.contains(event.target))closeQuick();});
    // A label click can focus the surrounding main before activating its checkbox.
    document.addEventListener('focusin',event=>{if(!quick.contains(event.target)&&!event.target.contains(quick))closeQuick();});
    quick.addEventListener('keydown',event=>{
      if(event.key!=='Escape')return;
      const open=quick.querySelector('.kb-quick-filter.is-open');
      if(!open)return;
      event.preventDefault();event.stopPropagation();
      open.querySelector('[data-quick-toggle]').focus();setQuickOpen(open,false);
    });
  }
  function render() {
    renderQuick();
    topUI=presentation.create({root,definitions:definitions.filter(d=>!quickKeys.includes(d.key)).sort((a,b)=>(b.key==='Marca')-(a.key==='Marca')),term,onChange:onFilterChange,onReset:resetFilters,
      onRemove:(key,value)=>{selected[key]=(selected[key]||[]).filter(item=>item!==value);limit=25;apply();}});
  }
  async function load() {
    records=[]; const ids=new Set();const visited=new Set();
    const source=new URL(location.href);source.searchParams.delete('page');source.searchParams.delete('spec');
    for(const key of [...source.searchParams.keys()])if(key.startsWith('filter.'))source.searchParams.delete(key);
    source.searchParams.set('section_id','klever-facet-products');
    source.searchParams.set('sort_by','created-ascending');
    const catalogRevision=String(Date.now());source.searchParams.set('_ks_catalog',catalogRevision);
    const initialNodes=[...list.querySelectorAll('[data-ks-product]')];
    const existing=new Map(initialNodes.map(node=>[node.dataset.productId,node]));
    const totalOnPage=Number(root.querySelector('#KleverVisibleProducts').dataset.total);
    let initialComplete=initialNodes.length===totalOnPage&&!([...new URL(location.href).searchParams.keys()].some(key=>key.startsWith('filter.')));
    let total=totalOnPage;
    const readPage=async url=>{
      const response=await fetch(url,{cache:'no-store',signal:AbortSignal.timeout(20000)});if(!response.ok)throw Error('Catalog unavailable');
      const page=new DOMParser().parseFromString(await response.text(),'text/html');
      const wrapper=page.querySelector('[data-facet-page]');if(!wrapper)throw Error('Missing category');
      return {page,wrapper};
    };
    const yieldControl=()=>new Promise(resolve=>{const channel=new MessageChannel();channel.port1.onmessage=()=>{channel.port1.close();channel.port2.close();resolve();};channel.port2.postMessage(null);});
    const consume=async ({page,wrapper})=>{
      if(Number(wrapper.dataset.total)!==total)throw Error('Catalog changed during loading');
      let processed=0;
      for(const node of page.querySelectorAll('[data-ks-product]')){
        if(ids.has(node.dataset.productId))continue;ids.add(node.dataset.productId);
        const product=JSON.parse(node.querySelector('[data-product-technical]').textContent);
        const fields=data.extract(product.description,{title:node.querySelector('.kb-product-row__title')?.textContent||'',type:product.type,category:root.dataset.collectionTitle});
        if(presentation)presentation.normalizeFields(fields);
        fields.Marca=product.vendor;fields.Subcategoría=product.type;
        const delivery=data.deliveryWindow(product.delivery,node.dataset.shipping,product.stock);if(delivery)fields['Plazo de entrega']=delivery;
        const previous=existing.get(node.dataset.productId);
        const unchanged=previous?.querySelector('[data-product-technical]')?.textContent===node.querySelector('[data-product-technical]').textContent;
        records.push({fields,node:unchanged?previous:node,search:data.normalize(product.description+' '+node.textContent)});
        if(++processed%25===0)await yieldControl();
      }
      status.textContent=`Revisando ${records.length} de ${total} productos…`;
    };
    if(initialComplete){await consume({page:list,wrapper:{dataset:{total:String(total)}}});}
    else{
      const first=await readPage(source.href);total=Number(first.wrapper.dataset.total);await consume(first);
      const pages=Number(first.wrapper.dataset.pages)||Math.ceil(total/250),next=first.wrapper.dataset.next;
      if(next){
        const target=new URL(next,source);if(target.origin!==source.origin||target.pathname!==source.pathname)throw Error('Invalid page');
        if(!Number.isInteger(pages)||pages<2||pages>80)throw Error('Invalid pagination');
        for(let page=2;page<=pages;page+=4){
          const requests=[];
          for(let n=page;n<=Math.min(page+3,pages);n++){const url=new URL(target);url.searchParams.set('page',String(n));url.searchParams.set('section_id','klever-facet-products');url.searchParams.set('sort_by','created-ascending');url.searchParams.set('_ks_catalog',catalogRevision);requests.push(readPage(url.href));}
          for(const result of await Promise.all(requests))await consume(result);
        }
      }
    }
    if(records.length!==total)throw Error('Incomplete category');
    const initialOrder=new Map(initialNodes.map((node,index)=>[node.dataset.productId,index]));
    records.sort((a,b)=>(initialOrder.get(a.node.dataset.productId)??Infinity)-(initialOrder.get(b.node.dataset.productId)??Infinity));
    const types=new Set(records.map(r=>r.fields.Subcategoría));
    definitions=data.facets(records,root.dataset.collectionTitle);
    if(quick){
      const brands=[...new Set(records.map(record=>record.fields.Marca).filter(Boolean))].sort((a,b)=>a.localeCompare(b,'es'));
      definitions=[{key:'Plazo de entrega',values:['1-2 Días Hábiles','2-3 Semanas']},{key:'Marca',values:brands},...definitions.filter(({key})=>!['Plazo de entrega','Marca'].includes(key))];
    }
    // Preserve only options that still exist after catalog changes.
    selected=Object.fromEntries(definitions.map(d=>[d.key,(selected[d.key]||[]).filter(v=>d.values.includes(v))]));
    root.dataset.technicalFilterOwner='true';
    root.querySelector('[data-category-pagination]')?.remove();
    render();apply(false);loading.hidden=true;overview.setAttribute('aria-busy','false');
  }
  function onFilterChange(event) {
    const input=event.target;if(!input.matches('input[type="checkbox"]'))return;
    selected[input.dataset.key]=filterInputs().filter(el=>el.dataset.key===input.dataset.key&&el.checked).map(el=>el.value);limit=25;apply();
  }

  quick?.addEventListener('change',onFilterChange);
  function resetFilters(){
    selected={[deliveryKey]:[...deliveryValues]};term='';limit=25;

    topUI?.resetSearch();apply();
  }

  more.addEventListener('click',()=>{limit+=25;apply();});
  async function start(){
    overview.setAttribute('aria-busy','true');loading.hidden=false;status.textContent='Preparando filtros de toda la categoría…';
    performance.mark('klever:filters-start');
    try{let lastError=null;for(let attempt=0;attempt<2;attempt++){try{await load();lastError=null;break;}catch(error){lastError=error;}}if(lastError)throw lastError;performance.mark('klever:filters-ready');root.dataset.filterLoadMs=performance.measure('klever:filters-duration','klever:filters-start','klever:filters-ready').duration.toFixed(1);performance.measure('klever:filters-load','klever:filters-start','klever:filters-ready');}catch(_){
      overview.setAttribute('aria-busy','false');status.textContent='No se pudieron preparar los filtros técnicos. El catálogo sigue disponible.';
      const retry=document.createElement('button');retry.type='button';retry.textContent='Reintentar filtros';retry.addEventListener('click',()=>{retry.remove();void start();});status.append(' ',retry);
    }
  }
  void start();
})();
